import BaseMystery from '../BaseMystery'

const FifthSorrow = () => {
	const imagesList = [
		"https://www.wga.hu/art/c/conti/crucifix.jpg",
	];

	const titleText = "Mary at the foot of the Cross";
	const scriptureQuote = "When Jesus saw his mother and the disciple there whom he loved, he said to his mother, \"Woman, behold, your son.\" Then he said to the disciple, \"Behold, your mother.\"";
	const scriptureCitation = "John 19:26-27 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=John%2019%3A25-27&version=NABRE";

	return (
		<BaseMystery titleText={titleText}
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FifthSorrow;